import React from "react";
import $ from "jquery";
import ReactTable from "react-table";
import Select from "react-select";
import {Button} from "reactstrap";
import Framework from "@beardeddevops/react.framework";
import APPCONFIG from "constants/Config";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";

const FFL_BOSS_API_VERSION = "v804";
const STATE_OPTIONS = [
	{"value":"AL","label":"Alabama"},{"value":"AK","label":"Alaska"},{"value":"AS","label":"American Samoa"},
	{"value":"AZ","label":"Arizona"},{"value":"AR","label":"Arkansas"},{"value":"AE","label":"Armed Forces Africa"},
	{"value":"AA","label":"Armed Forces Americas"},{"value":"AE","label":"Armed Forces Canada"},{"value":"AE","label":"Armed Forces Europe"},
	{"value":"AE","label":"Armed Forces Middle East"},{"value":"AP","label":"Armed Forces Pacific"},{"value":"CA","label":"California"},
	{"value":"CO","label":"Colorado"},{"value":"CT","label":"Connecticut"},{"value":"DE","label":"Delaware"},
	{"value":"DC","label":"District of Columbia"},{"value":"FM","label":"Federated States of Micronesia"},{"value":"FL","label":"Florida"},
	{"value":"GA","label":"Georgia"},{"value":"GU","label":"Guam"},{"value":"HI","label":"Hawaii"},
	{"value":"ID","label":"Idaho"},{"value":"IL","label":"Illinois"},{"value":"IN","label":"Indiana"},
	{"value":"IA","label":"Iowa"},{"value":"KS","label":"Kansas"},{"value":"KY","label":"Kentucky"},
	{"value":"LA","label":"Louisiana"},{"value":"ME","label":"Maine"},{"value":"MH","label":"Marshall Islands"},
	{"value":"MD","label":"Maryland"},{"value":"MA","label":"Massachusetts"},{"value":"MI","label":"Michigan"},
	{"value":"MN","label":"Minnesota"},{"value":"MS","label":"Mississippi"},{"value":"MO","label":"Missouri"},
	{"value":"MT","label":"Montana"},{"value":"NE","label":"Nebraska"},{"value":"NV","label":"Nevada"},
	{"value":"NH","label":"New Hampshire"},{"value":"NJ","label":"New Jersey"},{"value":"NM","label":"New Mexico"},
	{"value":"NY","label":"New York"},{"value":"NC","label":"North Carolina"},{"value":"ND","label":"North Dakota"},
	{"value":"MP","label":"Northern Mariana Islands"},{"value":"OH","label":"Ohio"},{"value":"OK","label":"Oklahoma"},
	{"value":"OR","label":"Oregon"},{"value":"PW","label":"Palau"},{"value":"PA","label":"Pennsylvania"},
	{"value":"PR","label":"Puerto Rico"},{"value":"RI","label":"Rhode Island"},{"value":"SC","label":"South Carolina"},
	{"value":"SD","label":"South Dakota"},{"value":"TN","label":"Tennessee"},{"value":"TX","label":"Texas"},
	{"value":"UT","label":"Utah"},{"value":"VT","label":"Vermont"},{"value":"VI","label":"Virgin Islands"},
	{"value":"VA","label":"Virginia"},{"value":"WA","label":"Washington"},{"value":"WV","label":"West Virginia"},
	{"value":"WI","label":"Wisconsin"},{"value":"WY","label":"Wyoming"}
];

export default class FFLLookup extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			data: [],
			loading: false,
			page: 0,
			pages: 0,
			limit: 10,
			search: props.currentFFL || "",
			filterState: null
		};
	}

	componentDidMount() {
		this.fetchData({
			page: 0,
			sorted: []
		});
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.currentFFL !== this.props.currentFFL && !this.state.search && this.props.currentFFL) {
			this.setState({search: this.props.currentFFL}, () => {
				this.fetchData({
					page: 0,
					sorted: []
				});
			});
		}

		if (prevState.search !== this.state.search) {
			if (this.searchTimeout) {
				clearTimeout(this.searchTimeout);
			}
			this.searchTimeout = setTimeout(() => {
				this.fetchData({
					page: 0,
					sorted: []
				});
			}, 350);
		}
	}

	componentWillUnmount() {
		if (this.searchTimeout) {
			clearTimeout(this.searchTimeout);
		}
	}

	getFflBossApiUrl = () => {
		const fflBossUrl = APPCONFIG.settings.fflBossURL();
		if (fflBossUrl.includes("beta.fflboss.com")) {
			return "https://beta.api.fflboss.com";
		}
		if (fflBossUrl.includes("app.fflboss.com")) {
			return "https://va1.api.fflboss.com";
		}
		return "https://dev.api.fflboss.com";
	};

	addToDealer = (ffl) => () => {
		if (typeof this.props.afterSave !== "undefined") {
			this.props.afterSave(ffl);
		}
	};

	handleSearchChange = (event) => {
		this.setState({
			search: event.target.value,
			page: 0
		});
	};

	handleStateChange = (option) => {
		this.setState({
			filterState: option,
			page: 0
		}, () => {
			this.fetchData({
				page: 0,
				sorted: []
			});
		});
	};

	fetchData = async (tableState) => {
		const state = tableState || {
			page: this.state.page,
			sorted: []
		};
		const sorted = state.sorted || [];
		const limit = state.pageSize || this.state.limit;
		const page = typeof state.page === "number" ? state.page : this.state.page;

		this.setState({loading: true});

		try {
			const response = await $.ajax({
				url: this.getFflBossApiUrl() + "/" + FFL_BOSS_API_VERSION + "/ffls",
				type: "GET",
				data: {
					filter: JSON.stringify(this.state.filterState ? {state: this.state.filterState.value, table: "firstLoad"} : {table: "firstLoad"}),
					search: this.state.search,
					search_field: "",
					sort: sorted[0] ? sorted[0].id : "ffl",
					order: sorted[0] && sorted[0].desc ? "desc" : "asc",
					limit,
					offset: page * limit,
					object: JSON.stringify({})
				}
			});

			const total = response.response && typeof response.response.total === "number" ? response.response.total : 0;
			this.setState({
				data: response.response && response.response.items ? response.response.items : [],
				loading: false,
				page,
				limit,
				pages: limit > 0 ? Math.ceil(total / limit) : 0
			});
		} catch (e) {
			this.setState({
				data: [],
				loading: false,
				page,
				limit,
				pages: 0
			});
		}
	};

	render() {
		const {data, pages, loading, limit, search, filterState} = this.state;
		const columns = [
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: (props) => (
					<Button className="primary-button" size={"sm"} block={true} onClick={this.addToDealer(props.original)}>
						<i className={"fa fa-plus"}/>
					</Button>
				)
			},
			{
				Header: "FFL",
				accessor: "ffl",
				width: 160
			},
			{
				Header: "License Name",
				accessor: "name_license",
			},
			{
				Header: "Trade Name",
				accessor: "name_business",
			},
			{
				Header: "Type",
				id: "oct_4",
				accessor: (obj) => obj.oct_4,
				width: 55
			},
			{
				Header: "Expiration",
				id: "expiration",
				filterable: false,
				sortable: false,
				accessor: (obj) => {
					let evaluationYear = new Date().getFullYear();
					let expirationOct = obj.oct_5;
					let month = expirationOct.substring(1, 2).alphaToMonth();
					let year = expirationOct.substring(0, 1).numToYear(evaluationYear);
					return month + " " + year;
				},
				width: 90
			},
			{
				Header: "Street",
				accessor: "street",
			},
			{
				Header: "City",
				accessor: "city",
			},
			{
				Header: "State",
				accessor: "state",
				width: 58
			},
			{
				Header: "Zip",
				id: "zip",
				accessor: (obj) => obj.zip.substring(0, 5),
				width: 65
			},
			{
				Header: "Phone",
				accessor: "phone",
				width: 95
			}
		];

		return (
			<Card>
				<CardContent>
					<div className="box-body">
						<div className="table-bar">
							<div className="d-flex" style={{gap: "12px", width: "100%"}}>
								<div style={{flex: 1}}>
									<input
										type="text"
										className="form-control"
										placeholder="Search FFLs"
										value={search}
										onChange={this.handleSearchChange}
									/>
								</div>
								<div style={{minWidth: "220px"}}>
									<Select
										classNamePrefix="select"
										isClearable={true}
										isSearchable={true}
										name="state"
										value={filterState}
										onChange={this.handleStateChange}
										placeholder={"State..."}
										options={STATE_OPTIONS}
									/>
								</div>
							</div>
						</div>
						<ReactTable
							key={`${pages}-${limit}-${filterState ? filterState.value : "all"}`}
							columns={columns}
							manual
							data={data}
							pages={pages}
							loading={loading}
							loadingText="Requesting Data"
							onFetchData={this.fetchData}
							onPageChange={(nextPage) => this.setState({page: nextPage})}
							onPageSizeChange={(pageSize) => this.setState({limit: pageSize, page: 0})}
							defaultSorted={[
								{
									id: "ffl",
									desc: false
								}
							]}
							showPagination={true}
							showPaginationTop={false}
							showPaginationBottom={true}
							showPageSizeOptions={true}
							defaultPageSize={limit}
							pageSize={limit}
							pageSizeOptions={[5, 10, 20, 50, 100]}
							className="-striped -highlight"
							minRows={0}
						/>
						<Framework.Elements.LoadingSpinner isLoading={loading}/>
					</div>
				</CardContent>
			</Card>
		);
	}
}
